import { useContext } from 'react'
import Context from './context'

export default () => useContext(Context)
